import React from 'react';
import LazyLoad from 'react-lazyload';
import { Link as NavLink } from 'react-router-dom';
import { event } from '@minerva-analytics/pantheon';
import CompatibilityIcon from '../../assets/compatibility_icon.png';
import { StyledButton, ContentCard } from '../../styled_constants';

import {
  CompatibilityHeader,
  CompatibilityText,
  CompatibilityImage,
  CompatibilityWrapper,
  MobileButton,
} from './CompatibilityCard.styles';

export const CompatibilityCard = () => {
  return (
    <ContentCard>
      <CompatibilityHeader>Find that love connection</CompatibilityHeader>
      <CompatibilityWrapper>
        <LazyLoad once>
          <CompatibilityImage src={ CompatibilityIcon } alt={`Heart Icon to show compatibility`} />
        </LazyLoad>
        <CompatibilityText>
          Use our Compatibility Calculator to determine the exact
          compatibility between your two signs!
        </CompatibilityText>
      </CompatibilityWrapper>
      <MobileButton>
        <NavLink to={ `/compatibility-calculator` }>
          <StyledButton
            type="submit"
            onClick={() => {
              event([`click`, `hero-compatibility`]);
            }}
          >
            Calculate compatibility
          </StyledButton>
        </NavLink>
      </MobileButton>
    </ContentCard>
  );
};


export default CompatibilityCard;
